import { render, staticRenderFns } from "./class-admin-base.view.vue?vue&type=template&id=69c7a80a&scoped=true&"
import script from "./class-admin-base.view.ts?vue&type=script&lang=ts&"
export * from "./class-admin-base.view.ts?vue&type=script&lang=ts&"
import style0 from "./class-admin-base.view.scss?vue&type=style&index=0&id=69c7a80a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c7a80a",
  null
  
)

export default component.exports